import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    InputAdornment,
    IconButton,
    FormControl,
    InputLabel,
    Input,
    FormControlLabel
} from "@mui/material";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { Visibility,VisibilityOff } from "@mui/icons-material";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";

import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SOLogout from "../../components/Logout/SOLogout";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { partnerGetDealerMappingListReq } from '../../redux/actions/getMappingDealerListAction';
import { partnerDeleteDealerListReq } from "../../redux/actions/deleteDealerAgentAction"
import { partnerDealerListReq } from '../../redux/actions/dealerListPartnerAction';
import { partnerEditDealerListReq } from "../../redux/actions/editDealerListPartnerAction";
import { partnerDivisionListReq } from '../../redux/actions/divisionListAgentPartnerAction'
import { partnerDistrictListReq } from "../../redux/actions/districtListAgentPartnerAction"
import { partnerThanaListReq } from "../../redux/actions/thanaListAgentPartnerAction";
import { partnerUnionListReq } from "../../redux/actions/unionListAgentPartnerAction";
import { getRoleDropLists } from "../../redux/actions/getRoleDropListForPartnerAction";


const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650
    },
    margin: {
        margin: theme.spacing(1)
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        width: "25ch"
    }
}));

const AgentDealerMapping = () => {
    const [pageToggle, setPageToggle] = useState(false);
    const navigate = useHistory();

    const classes = useStyles();
    const dispatch = useDispatch();

    const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [deleteNotification, setDeleteNotification] = useState(false)
    const [emailOtp, setEmailOtp] = useState("");

    const [getMappingDealerListStatus, setGetMappingDealerListStatus] = useState(false);
    const [getMappingDealerListArray, setGetMappingDealerListArray] = useState("");

    const [deleteDealerAgentMasterStatus, setDeleteDealerAgentMasterStatus] = useState(false)
    const [deleteDealerAgentMasterArray, setDeleteDealerAgentMasterArray] = useState("")

    const [getDealerListStatus, setGetDealerListStatus] = useState(false);
    const [getDealerListArray, setGetDealerListArray] = useState([]);

    const [editDealerListStatus, setEditDealerListStatus] =
        useState(false);
    const [editDealerListResArray, setEditDealerListResArray] =
        useState("");

    const [addDealerListStatus, setAddDealerListStatus] =
        useState(false);
    const [addDealerListResArray, setAddDealerListResArray] =
        useState("");

    const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] = useState(false);
    const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] = useState([]);

    const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] = useState(false);
    const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] = useState([]);


    const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] = useState(false);
    const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState([]);

    const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] = useState(false);
    const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState([]);

    const [GetRoleDropListStatus, setGetRoleDropListStatus] = useState(false);
    const [GetRoleDropListArray, setGetRoleDropListArray] = useState([]);

    const [editOpen, setEditOpen] = useState(false)
    const [addDealerOpen, setAddDealerOpen] = useState(false)

    const [addEditDsrNotification, setAddEditDsrNotification] = useState(false)
    const [addDsrNotification, setAddDsrNotification] = useState(false)

    const [editDivision, setEditDivision] = useState("");
    const [editDistrict, setEditDistrict] = useState("");
    const [editThana, setEditThana] = useState("");
    const [editUnion, setEditUnion] = useState("");
    const [getAgentList, setGetAgentList] = useState("");

    const [agentComboName, setAgentComboName] = useState("")
    const [Role, setRole] = useState("");
    // const [DealerRole, setDealerRole] = useState("");
    // console.log(DealerRole, "dealerroles")

    const [mobileNo, setMobileNo] = useState("")
    const [getDivision, setGetDivision] = useState("");
    const [getDistrict, setGetDistrict] = useState("");
    const [getThana, setGetThana] = useState("");
    const [getUnion, setGetUnion] = useState("");
    const [PhoneNo, setPhoneNo] = useState("")
    const [code, setCode] = useState("");
    const [getIsDealUsed, setGetIsDealUsed] = useState("");
    const [getAgentComboId, setGetAgentComboId] = useState("");
    const [getDealerName, setGetDealerName] = useState("");
    const [getPersonId, setGetPersonId] = useState("");
    const [usernametable, setusernametable] = useState('');
    const [countrycodetable, setcountrycodetable] = useState('');
    const [editFinalValue, seteditFinalValue] = useState('');


    const [getMappingId, setGetMappingId] = useState("");


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleClose = () => {
        setDeleteOpen(false)
        setEditOpen(false)
        setAddDealerOpen(false)

    }
    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setDeleteNotification(false);
        setAddEditDsrNotification(false);
        setAddDsrNotification(false);
        setEditOpen(false)
        setAddDealerOpen(false)
        setDeleteOpen(false)
    };
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);

    const [user, setUser] = useState({
        dsrId: "",
        dsrName: "",
        dsrNumber: "",
        thana: "",
        union: "",
        division: "",
        district: "",
        agentList: "",
        getRole: "",


    });
    const {
        dsrId,
        dsrName,
        dsrNumber,
        getRole,
        division,
        district,
        thana,
        union,
        agentList,

    } = user

    const EditDealerList = (
        agentComboName,
        Role,
        mobileNo,
        getDivision,
        getDistrict,
        getUnion,
        getThana,
        getIsDealUsed,
        personIds,
        codes,
        numbers,
        username,
        countrycode
        // PhoneNo,
        // getAgentComboId,
        // getDealerName,
        // getMappingId,





    ) => {
        setAgentComboName(agentComboName);
        setRole(Role);
        setMobileNo(mobileNo);
        setGetDivision(getDivision);
        setGetDistrict(getDistrict);
        setGetUnion(getUnion);
        setGetThana(getThana);
        setGetIsDealUsed(getIsDealUsed);
        setCode(codes);
        setPhoneNo(numbers);
        setGetPersonId(personIds);
        setGetDealerName(getDealerName);
        setGetMappingId(numbers);
        setusernametable(username);
        setcountrycodetable(countrycode);
        setEditOpen(true);
    }

    const AddDealerList = (
        agentComboName,
        Role,
        mobileNo,
        getDivision,
        getDistrict,
        getUnion,
        getThana,
        getIsDealUsed,
        personIds,
        codes,
        numbers
        // agentComboName,
        // Role,
        // mobileNo,
        // getDivision,
        // getDistrict,
        // getUnion,
        // getThana,
        // getIsDealUsed,
        // code,
        // getAgentComboId,
        // getDealerName,
        // getMappingId


    ) => {

        setAgentComboName(agentComboName);
        setRole(Role);
        setMobileNo(mobileNo);
        setGetDivision(getDivision);
        setGetDistrict(getDistrict);
        setGetUnion(getUnion);
        setGetThana(getThana);
        setGetIsDealUsed(getIsDealUsed);
        setCode(codes);
        setPhoneNo(numbers);
        setGetPersonId(personIds);
        setGetDealerName(getDealerName);
        setGetMappingId(numbers);
        setAddDealerOpen(true)
    }
    useEffect(() => {
        console.log(getIsDealUsed, "///////")
    }, [getIsDealUsed]);

    const onInputChangeMod = ({ target: { name, value } }, type) => {

        const obj = {
            ...user,

        };
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            obj[name] = value
        }
        setUser(obj);
    }
    const getMappingDealerListRes = useSelector(
        ({ partnerGetMappingDealerLists }) => partnerGetMappingDealerLists
    );

    const deleteDealerAgentRes = useSelector(
        ({ partnerDeleteDealerLists }) => partnerDeleteDealerLists
    );

    const getDealerListRes = useSelector(({ partnerDealerLists }) => partnerDealerLists);

    const getEditDealerListRes = useSelector(({ partnerEditDealerLists }) => partnerEditDealerLists)

    const getAddDealerListRes = useSelector(({ partnerEditDealerLists }) => partnerEditDealerLists)

    const setDivisionList = useSelector(
        ({ partnerDivisionListAgent }) => partnerDivisionListAgent
    )
    const setDistrictList = useSelector(
        ({ partnerDistrictListAgent }) => partnerDistrictListAgent
    )

    const setThanaList = useSelector(
        ({ partnerThanaListAgent }) => partnerThanaListAgent
    )

    const setUnionList = useSelector(
        ({ partnerUnionListAgent }) => partnerUnionListAgent
    )

    const getRoleDropListRes = useSelector(
        ({ partnerGetRoleDropLists }) => partnerGetRoleDropLists
    )

    const handleChange = ({ target: { name, value } }) => {
        if (name === "AgentComboName") {
            // setAgentComboName(value == "Select Dsr" ? "" : value);
            setAgentComboName(value)
        }
        if (name === "Role") {
            // setRole(value);
            // setRole(value == "All" ? "" : value);
            setRole(value == "Select Role" ? "" : value);




        }
        // if (name === "DealerRole") {
        //     setDealerRole(value)
        // }


        if (name === "MobileNumber") {
            setMobileNo(value);
        }

        if (name === "Division") {
            setGetDivision(value)
        }

        if (name === "District") {
            setGetDistrict(value)
        }

        if (name === "Thana") {
            setGetThana(value)
        }

        if (name === "Union") {
            setGetUnion(value)
        }
        if (name === "agentList") {
            setGetAgentList(value == "All" ? "" : value);

        }
        if (name === "EditDivision") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDivision(value == "Select Division" ? "" : value);
        }
        if (name === "EditDistrict") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDistrict(value == "Select District" ? "" : value);
        }
        if (name === "EditThana") {

            setEditThana(value == "Select Thana" ? "" : value);
        }
        if (name === "EditUnion") {

            setEditUnion(value == "Select Union" ? "" : value);
        }

        if (name === "getIsDealUsed") {
            setGetIsDealUsed(value);
            // console.log('Final value: ', value)
            // seteditFinalValue(value);
            // // setLevel(value);
            // console.log('Dropdown: ', getIsDealUsed)
        }
    };
    const sendCustomerId = (personId) => {
        // setPageToggle(true);
        navigate.push({
            pathname: `/index/AgentViewDealer`,
            state: { param1: `${personId}` }
        });
    };



    const setGetRoleDropListReq = () => {
        setGetRoleDropListStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || ""


            }
        };
        dispatch(getRoleDropLists(req, authToken));
    };

    const GetRoleDropListFunc = () => {
        if (GetRoleDropListStatus) {
            if (getRoleDropListRes.data.status == "success") {
                setGetRoleDropListArray([].concat(getRoleDropListRes.data.currencyList));
            }
            if (getRoleDropListRes.data.status == "failed") {
                setGetRoleDropListArray(getRoleDropListRes.data);
                if (
                    getRoleDropListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRoleDropListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        GetRoleDropListFunc();
    }, [getRoleDropListRes.data.status]);



    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            setGetRoleDropListReq();
        }
    }, [regenerateTokenRes.data.status]);


    const getEditDealerListReq = () => {
        setEditDealerListStatus(true)
        const request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                dealerId: getIsDealUsed.split("-")[0],
                agentId: getPersonId,
                mappindId: code,
                role: Role,
                userName: "",
                mobileNumber: mobileNo,
                dealerName: "",
                phone: "",
                // dealerName: getIsDealUsed.split("-")[1],
                // id: idNum,
                // customerId: custId,
                // dsrId: getEmailOtp.split("-")[0]
            }
        }


        // console.log(request, "request")
        dispatch(partnerEditDealerListReq(request, authToken))
        setEditOpen(false)

    }

    const editDealerListFunc = () => {
        if (editDealerListStatus) {
            if (getEditDealerListRes.data.status == "success") {
                setEditDealerListResArray(getEditDealerListRes.data)
                setAddEditDsrNotification(true)
                partnerGetMappingDealerListReq()

            }
            if (getEditDealerListRes.data.status == "failed") {
                setEditDealerListResArray(getEditDealerListRes.data)
                setAddEditDsrNotification(true)
            }
        }
    }

    useEffect(() => {
        editDealerListFunc()
    }, [getEditDealerListRes.data.status]);


    const getAddDealerListReq = () => {
        setAddDealerListStatus(true)
        const request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                dealerId: getIsDealUsed.split("-")[0],
                agentId: getPersonId,
                mappindId: "",
                role: Role,
                userName: getIsDealUsed.split("-")[1],
                mobileNumber: mobileNo,
                dealerName: "",
                phone: getIsDealUsed.split("-")[3],
                // walletOwnerId: regenerateTokenRes.data.partnerId,
                // dealerId: getIsDealUsed.split("-")[0],
                // agentId: code,
                // mappindId: "",
                // role: Role,
                // userName: getDealerName,
                // mobileNumber: mobileNo,
                // dealerName: "",
                // phone: "",
                // id: idNum,
                // customerId: custId,
                // dsrId: getEmailOtp.split("-")[0]
            }
        }



        dispatch(partnerEditDealerListReq(request, authToken))
        setAddDealerOpen(false)

    }

    const addDealerListFunc = () => {
        if (addDealerListStatus) {
            if (getAddDealerListRes.data.status == "success") {
                setAddDealerListResArray(getAddDealerListRes.data)
                setAddDsrNotification(true)
                partnerGetMappingDealerListReq()

            }
            if (getAddDealerListRes.data.status == "failed") {
                setAddDealerListResArray(getAddDealerListRes.data)
                setAddDsrNotification(true)
            }
        }
    }

    useEffect(() => {
        addDealerListFunc()
    }, [getAddDealerListRes.data.status]);



    const setAddUpdateDivisionListReq = () => {
        setSetAddUpdateDivisionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",


            }
        }
        dispatch(partnerDivisionListReq(req, authToken))
    }

    const AddUpdateDivisionListFunc = () => {
        if (setAddUpdateDivisionListStatus) {
            if (setDivisionList.data.status == "success") {
                setSetAddUpdateDivisionListArray(setDivisionList.data.list);
            }
            if (setDivisionList.data.status == "failed") {
                setSetAddUpdateDivisionListArray(setDivisionList.data);
            }
        }
    };
    useEffect(() => {
        AddUpdateDivisionListFunc();
    }, [setDivisionList.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            setAddUpdateDivisionListReq()

        }
    }, [regenerateTokenRes.data.status])

    const setAddUpdateDistrictListReq = () => {
        setSetAddUpdateDistrictListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDivision

            }
        }
        dispatch(partnerDistrictListReq(req, authToken))
    }
    const AddUpdateDistrictListFunc = () => {
        if (setAddUpdateDistrictListStatus) {
            if (setDistrictList.data.status == "success") {
                setSetAddUpdateDistrictListArray(setDistrictList.data.list);
            }
            if (setDistrictList.data.status == "failed") {
                setSetAddUpdateDistrictListArray(setDistrictList.data);
            }
        }
    };

    useEffect(() => {
        if (editDivision) {
            setAddUpdateDistrictListReq()
        }
    }, [editDivision])

    useEffect(() => {
        AddUpdateDistrictListFunc()
    }, [setDistrictList.data.status])

    const setAddUpdateThanaListReq = () => {
        setSetAddUpdateThanaListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict

            }
        }
        dispatch(partnerThanaListReq(req, authToken))
    }
    const AddUpdateThanaListFunc = () => {
        if (setAddUpdateThanaListStatus) {
            if (setThanaList.data.status == "success") {
                setSetAddUpdateThanaListArray(setThanaList.data.list);
            }
            if (setThanaList.data.status == "failed") {
                setSetAddUpdateThanaListArray(setThanaList.data);
            }
        }
    };
    useEffect(() => {
        if (editDistrict) {
            setAddUpdateThanaListReq()
        }
    }, [editDistrict])
    useEffect(() => {
        AddUpdateThanaListFunc();
    }, [setThanaList.data.status]);

    // useEffect(() => {
    //     if (district) {
    //         setAddUpdateThanaListReq()
    //     }
    // }, [district])


    const setAddUpdateUnionListReq = () => {
        setSetAddUpdateUnionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict,
                thana: editThana

            }
        }
        dispatch(partnerUnionListReq(req, authToken))
    }
    const AddUpdateUnionListFunc = () => {
        if (setAddUpdateUnionListStatus) {
            if (setUnionList.data.status == "success") {
                setSetAddUpdateUnionListArray(setUnionList.data.list);
            }
            if (setUnionList.data.status == "failed") {
                setSetAddUpdateUnionListArray(setUnionList.data);
            }
        }
    };



    useEffect(() => {
        setAddUpdateUnionListReq()
    }, [editDivision, editThana])

    useEffect(() => {
        AddUpdateUnionListFunc();
    }, [setUnionList.data.status]);
    useEffect(() => {

        // setEditDivision('');
        setEditDistrict('');
        setEditThana('');
        setEditUnion('')

    }, [editDivision])

    const partnerGetMappingDealerListReq = () => {
        setGetMappingDealerListStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                id: dsrId,
                name: dsrName,
                mobileNumber: dsrNumber,
                role: Role,
                division: editDivision === "Select Divison" ? "" : editDivision,

                district: editDistrict,
                thana: editThana,
                union: editUnion,
                list: getAgentList


            }
        }
        dispatch(partnerGetDealerMappingListReq(req, authToken))
    }

    const getMappingDealerListFunc = () => {
        if (getMappingDealerListStatus) {
            if (getMappingDealerListRes.data.status == "success") {
                setGetMappingDealerListArray([].concat(getMappingDealerListRes.data.customerMasterDetailsRequestVOList))
                // dealerAddDsrFunc()
                setIsLoading(false)
            }
            if (getMappingDealerListRes.data.status == "failed") {
                setGetMappingDealerListArray(getMappingDealerListRes.data)
                setIsLoading(false)
            }
            if (getMappingDealerListRes.data.status == "NOT FOUND") {
                setGetMappingDealerListArray(getMappingDealerListRes.data)
                setIsLoading(false)
            }
        }
    }
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            partnerGetMappingDealerListReq();
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        getMappingDealerListFunc()
    }, [getMappingDealerListRes.data.status])


    const deleteUserFunc = (code) => {
        // if (deleteDealerDsrRes.data.status == "success") {

        // }
        // setEmailOtp(emailOtp)
        setCode(code)
        setDeleteOpen(true);
    };

    const deleteDealerAgentReq = () => {
        setDeleteDealerAgentMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: regenerateTokenRes.data.partnerId,
                id: code
            }
        }
        dispatch(partnerDeleteDealerListReq(req, authToken));
        setDeleteOpen(false)


    }

    const dealerDeleteAgentFunc = () => {
        if (deleteDealerAgentMasterStatus) {
            if (deleteDealerAgentRes.data.status == "success") {
                setDeleteDealerAgentMasterArray(deleteDealerAgentRes.data)
                setDeleteNotification(true)
                partnerGetMappingDealerListReq()

            }
            if (deleteDealerAgentRes.data.status == "failed") {
                setDeleteDealerAgentMasterArray(deleteDealerAgentRes.data)
                setDeleteNotification(true)
            }
        }
    }
    useEffect(() => {
        dealerDeleteAgentFunc()
    }, [deleteDealerAgentRes.data.status])


    const dealerListPartnerReq = () => {
        setGetDealerListStatus(true);
        const Req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                division: division,
                district: district,
                thana: thana,
                union: union,
            }
        };
        dispatch(partnerDealerListReq(Req, authToken));
    };

    const DealerListPartnerFunc = () => {
        if (getDealerListStatus) {
            if (getDealerListRes.data.status == "success") {
                setGetDealerListArray([].concat(getDealerListRes.data.actionList));
            }
            if (getDealerListRes.data.status == "failed") {
                setGetDealerListArray(getDealerListRes.data);
                if (
                    getDealerListRes.data.description == "session out" ||
                    getDealerListRes.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        DealerListPartnerFunc();
    }, [getDealerListRes.data.status]);


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            dealerListPartnerReq();
        }
    }, [regenerateTokenRes.data.status]);

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid container style={{ padding: "25px", justifyContent: "right" }}>
                        {/* <Grid item md={7} sm={12} lg={5}></Grid> */}
                        <Grid item md={3} sm={12} xs={12} lg={2}>
                            <NavLink to="/index/DealerMultipleMapping">
                                <CustomButton
                                    style={{
                                        padding: "8px",
                                        margin: "0 8px"
                                    }}
                                >
                                    Multiple mapping
                                </CustomButton>
                            </NavLink>
                        </Grid>
                        {/* <Grid item md={3} sm={12} xs={12} lg={2}>
                            <NavLink to="/index/DealerAgentUpload">
                                <CustomButton
                                    style={{
                                        padding: "8px",
                                        margin: "0 8px"
                                    }}
                                >
                                    Agent upload
                                </CustomButton>
                            </NavLink>
                        </Grid> */}
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Number"
                                fullWidth={true}
                                name="dsrNumber"
                                value={dsrNumber}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "number")}

                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Name"
                                fullWidth={true}
                                name="dsrName"
                                value={dsrName}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "alphabet")}

                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Id"
                                fullWidth={true}
                                name="dsrId"
                                value={dsrId}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "number")}
                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Role"
                                fullWidth={true}
                                name="Role"
                                // value={getRole || ""}
                                defaultValue={"Select Role" || Role}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                {getRoleDropListRes.success && [].concat(getRoleDropListRes.data.currencyList)
                                    .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                                {/* <MenuItem value="MERCHANT">MERCHANT</MenuItem> */}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Division"
                                fullWidth={true}
                                // name="division"
                                // defaultValue={division || "Select Divison"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditDivision"
                                value={editDivision || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select Divison" selected="Select Divison">
                                    Select Division
                                </MenuItem>
                                {/* {setDivisionList.success} */}
                                {setDivisionList.success &&
                                    setDivisionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="District"
                                fullWidth={true}
                                // name="district"
                                // defaultValue={district || "Select District"}
                                // // onChange={(e) => onInputChangeMod(e)}
                                name="EditDistrict"
                                value={editDistrict || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select District" selected="Select District">
                                    Select District
                                </MenuItem>
                                {setDistrictList.success &&
                                    setDistrictList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Thana/Upazilla"
                                fullWidth={true}
                                // name="thana"
                                // defaultValue={thana || "Select Thana/Upazilla"}

                                name="EditThana"
                                value={editThana || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                    Select Thana/Upazilla
                                </MenuItem>

                                {setThanaList.success &&
                                    setThanaList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Union/Ward"
                                fullWidth={true}
                                // name="union"
                                // defaultValue={union || "Select Union/Ward"}
                                name="EditUnion"
                                value={editUnion || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                    Select Union/Ward
                                </MenuItem>
                                {setUnionList.success &&
                                    setUnionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Select Agent List"
                                fullWidth={true}
                                name="agentList"
                                // value={getRole || ""}
                                defaultValue={"All" || getAgentList}
                                onChange={handleChange}
                            >
                                <MenuItem value="All" selected="All">
                                    All
                                </MenuItem>
                                <MenuItem value="wDealer">WITH-DSR</MenuItem>
                                <MenuItem value="woDealer">WITHOUT-DSR</MenuItem>

                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>

                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={partnerGetMappingDealerListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                {isLoading ? (
                    <LoadingSpinner />

                ) : getMappingDealerListArray.length == undefined ||
                    !getMappingDealerListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="">
                                <Table
                                    className={classes.table}

                                    // size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow
                                            style={{ background: "#00b9f5" }}
                                            className="themeBackground"
                                        >
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Agent/Merchant/Combo ID	{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Agent/Merchant/Combo Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Mob No
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Division{" "}
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                District
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Thana
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Union
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Dealer Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Dealer Mob no
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {/* <TableHead>
                                        <TableRow className="themeBackground">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Agent/Merchant/Combo ID	{" "}

                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Agent/Merchant/Combo Name

                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Customer/Merchant ID{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Customer/Merchant Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Wallet Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Currency
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Balance
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead> */}
                                    <TableBody className="text-nowrap my-3">
                                        {getMappingDealerListArray &&
                                            []
                                                .concat(getMappingDealerListArray)
                                                .slice
                                                (
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                // marginTop: "1rem",
                                                                // marginLeft: "rem",
                                                                // color: "#00b9f5",
                                                                cursor: "pointer",
                                                                fontWeight: "600"
                                                            }}
                                                            className="themeColor"
                                                        >
                                                            <span
                                                                onClick={() => sendCustomerId(row.personId)}
                                                            >
                                                                {row.personId}
                                                            </span>
                                                        </TableCell>
                                                        {/* <TableCell align="center">
                                                            {row.customerId}
                                                        </TableCell> */}
                                                        <TableCell align="center">
                                                            {row.customerName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.mobile}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.division}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.district}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.thana}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.tradingUnion}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.userRole}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.userName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.phoneNo}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                        >
                                                            {/* <Tooltip title="Add DSR"> */}
                                                            {row.userName == "-" ? (
                                                                <>
                                                                    <Tooltip title="Add Dealer">

                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px",
                                                                                // margin: "0 8px"
                                                                            }}
                                                                            onClick={() =>
                                                                                AddDealerList(
                                                                                    row.customerName,
                                                                                    row.userRole,
                                                                                    row.mobile,
                                                                                    row.division,
                                                                                    row.district,
                                                                                    row.tradingUnion,
                                                                                    row.thana,
                                                                                    row.isDealUsed,
                                                                                    row.personId,
                                                                                    row.code,
                                                                                    row.phoneNo
                                                                                    // row.customerName,
                                                                                    // row.userRole,
                                                                                    // row.mobile,
                                                                                    // row.division,
                                                                                    // row.district,
                                                                                    // row.tradingUnion,
                                                                                    // row.thana,
                                                                                    // row.isDealUsed,
                                                                                    // row.personId,
                                                                                    // row.code,
                                                                                )
                                                                            }
                                                                        >
                                                                            Add DEALER
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                </>
                                                            ) : (

                                                                // <CustomButton
                                                                //     style={{
                                                                //         padding: "8px",
                                                                //         margin: "0 8px"
                                                                //     }}
                                                                //     onClick={() =>
                                                                //         AddDsrList(

                                                                //             row.customerName,
                                                                //             row.userRole,
                                                                //             row.mobNumber,
                                                                //             row.division,
                                                                //             row.state,
                                                                //             row.city,
                                                                //             row.union,
                                                                //             row.emailOtp,

                                                                //             row.customerId,
                                                                //             // row.idNumber
                                                                //         )
                                                                //     }
                                                                // >
                                                                //     Add DSR
                                                                // </CustomButton>
                                                                <>
                                                                    <Tooltip title="Delete">
                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px",
                                                                                // margin: "0 8px"

                                                                            }}
                                                                            onClick={() =>
                                                                                deleteUserFunc(row.code)
                                                                            }
                                                                        >
                                                                            {
                                                                                <DeleteIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            }
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                    <Tooltip title="Edit">

                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px",
                                                                                // margin: "0 8px"

                                                                            }}
                                                                            onClick={() =>
                                                                                EditDealerList(
                                                                                    row.customerName,
                                                                                    row.userRole,
                                                                                    row.mobile,
                                                                                    row.division,
                                                                                    row.district,
                                                                                    row.tradingUnion,
                                                                                    row.thana,
                                                                                    row.isDealUsed,
                                                                                    row.personId,
                                                                                    row.code,
                                                                                    row.phoneNo,
                                                                                    row.userName,
                                                                                    row.countryCode



                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                <EditIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            }
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                </>
                                                            )
                                                            }
                                                            {/* </Tooltp> */}
                                                            {/* <Tooltip title="Edit">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        EditDsrList(

                                                                            row.customerName,
                                                                            row.userRole,
                                                                            row.mobNumber,
                                                                            row.division,
                                                                            row.state,
                                                                            row.city,
                                                                            row.union,
                                                                            row.emailOtp,

                                                                            row.customerId,
                                                                            row.idNumber

                                                                        )
                                                                    }
                                                                >

                                                                    <EditIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />

                                                                </CustomButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        deleteUserFunc(row.idNumber)
                                                                    }
                                                                >

                                                                    <DeleteIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />

                                                                </CustomButton>
                                                            </Tooltip> */}

                                                        </TableCell>

                                                    </TableRow>
                                                )
                                                )
                                        }
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={[].concat(getMappingDealerListArray).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Card>
                    </div>
                )
                }
            </Layout>

            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                padding: "8px"
                            }}
                            // variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                width: "60px"
                            }}
                            onClick={deleteDealerAgentReq}

                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Update Dealer Mapping</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Agent/Combo Name"
                            fullWidth={true}
                            name="AgentComboName"
                            value={agentComboName || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="Role"
                            value={Role || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Mobile No"
                            fullWidth={true}
                            name="MobileNumber"
                            value={mobileNo || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Divison"
                            fullWidth={true}
                            name="Division"
                            value={getDivision || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="District"
                            fullWidth={true}
                            name="District"
                            value={getDistrict || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Thana"
                            fullWidth={true}
                            name="Thana"
                            value={getThana || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Union"
                            fullWidth={true}
                            name="Union"
                            value={getUnion || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getIsDealUsed"
                                // value={`${getIsDealUsed}-${usernametable}-${PhoneNo}-${countrycodetable}` || ""}
                                value={getIsDealUsed}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >
                                {/* <MenuItem value="Select Dsr" selected="Select Level">
                                    Select Dsr
                                </MenuItem> */}

                                {/* {setDsrList.success} */}
                                {/* <MenuItem value="BASIC">BASIC</MenuItem> */}
                                {getDealerListRes.success && [].concat(getDealerListRes.data.actionList)
                                    .map((x) => <MenuItem value={x.split('-')[0]}
                                    // .map((x) => <MenuItem value={x}
                                    >{x}</MenuItem>)}

                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getEditDealerListReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>

            <div>
                <Dialog open={addDealerOpen} onClose={handleClose}>
                    <DialogTitle>ADD Dealer Mapping</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Agent/Combo Name"
                            fullWidth={true}
                            name="AgentComboName"
                            value={agentComboName || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="Role"
                            value={Role || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Mobile No"
                            fullWidth={true}
                            name="MobileNumber"
                            value={mobileNo || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Divison"
                            fullWidth={true}
                            name="Division"
                            value={getDivision || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="District"
                            fullWidth={true}
                            name="District"
                            value={getDistrict || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Thana"
                            fullWidth={true}
                            name="Thana"
                            value={getThana || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Union"
                            fullWidth={true}
                            name="Union"
                            value={getUnion || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getIsDealUsed"
                                value={getIsDealUsed || ""}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >
                                {/* <MenuItem value="" selected="Select Level">
                                    Select Dsr
                                </MenuItem> */}
                                {/* {setDsrList.success} */}
                                {/* <MenuItem value="BASIC">BASIC</MenuItem> */}
                                {getDealerListRes.success && [].concat(getDealerListRes.data.actionList)
                                    .map((x) => <MenuItem value={x}
                                    // selected={() => {
                                    //     getEmailOtp == x.substring(0, 6) ? "" : "undefined"
                                    // }}
                                    // selected={dsrDropdown(x)}
                                    // selected={'190032-Soham-7875612343'}
                                    >{x}</MenuItem>)}

                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getAddDealerListReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>




            {deleteDealerAgentRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDealerAgentMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {deleteDealerAgentRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDealerAgentMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getEditDealerListRes.data.status == "success" && (
                <div>
                    <Dialog open={addEditDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editDealerListResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getEditDealerListRes.data.status == "failed" && (
                <div>
                    <Dialog open={addEditDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editDealerListResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {getAddDealerListRes.data.status == "success" && (
                <div>
                    <Dialog open={addDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDealerListResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getAddDealerListRes.data.status == "failed" && (
                <div>
                    <Dialog open={addDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDealerListResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

        </>
    )
}

export default AgentDealerMapping